module.exports = __webpack_public_path__ + "static/img/10.1fa9e2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10.jpg
// module id = 200
// module chunks = 0